import React from 'react';
import "./neural-loader.style.scss";
export const NeuralLoader = () => {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "neural-loader-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "neural-loader-dot"
  })));
};